import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from '../svgs/multipleCars.svg'

const MultipleCars: React.VFC<SvgIconProps> = props => <SvgIcon viewBox="0 0 70 30" component={Icon} {...props} fill="currentColor" />
export default MultipleCars
